import {
  Printer,
  FileText,
  Upload,
  Calendar,
  ClipboardList,
  Trash2,
} from "lucide-react";
import moment from "moment";
import { TooltipText } from "../ui/tooltip";

const getStatusColor = (status) => {
  switch (status?.toUpperCase()) {
    case "PENDING":
      return "bg-yellow-100 text-yellow-800 border-yellow-300";
    case "COMPLETED":
      return "bg-green-100 text-green-800 border-green-300";
    case "IN TRANSIT":
      return "bg-blue-100 text-blue-800 border-blue-300";
    default:
      return "bg-gray-100 text-gray-800 border-gray-300";
  }
};
export const getLoadPlanColumns = ({
  selectedPlans,
  loadList,
  handleSelectAll,
  handleSelectPlan,
  onEditPlan,
  setSelectedOrderId,
}) => {
  return [
    {
      key: "print",
      label: () => (
        <button className="text-xs font-semibold uppercase">PRINT</button>
      ),
      render: () => (
        <button     className="w-6 h-6 rounded flex items-center justify-center transition-all bg-blue-100 text-blue-700 hover:bg-blue-200">
          <Printer className="w-4 h-4" />
        </button>
      ),
    },
    {
      key: "select",
      label: () => (
        <input
          type="checkbox"
          onChange={handleSelectAll}
          checked={selectedPlans.length === loadList.length}
        />
      ),
      render: (row) => (
        <input
          type="checkbox"
          checked={selectedPlans.includes(row?.loId)}
          onChange={() => handleSelectPlan(row?.loId)}
        />
      ),
    },
    {
      key: "loNumber",
      label: "Load Plan #",
      render: (row) => (
        <span
          onClick={() => onEditPlan(row)}
          className="text-sm font-semibold text-[#0072FF] cursor-pointer hover:underline"
        >
          {row?.loNumber || "-"}
        </span>
      ),
    },
    {
      key: "shipmentNumber",
      label: "Shipment #",
      render: (row) => row?.shipmentNumber || "-",
    },
    {
      key: "salesOrderNo",
      label: "Sales Order #",
      render: (row) => row?.salesOrderNo || "-",
    },
    {
      key: "poNumber",
      label: "Purchase Order #",
      render: (row) => row?.poNumber || "-",
    },
    {
      key: "loDtae",
      label: "Order Date",
      render: (row) =>
        row?.loDtae ? moment(row.loDtae).format("DD MMM YYYY") : "-",
    },

    {
      key: "loShipByDate",
      label: "Ship By Date",
      render: (row) =>
        row?.loShipByDate ? moment(row.loShipByDate).format("DD MMM YYYY") : "-",
    },

    {
      key: "customer",
      label: "Customer",
      render: (row) => (
        <TooltipText content={row?.customer}>
          <span className="block max-w-[150px] truncate">
            {row?.customer || "-"}
          </span>
        </TooltipText>
      ),
    },

    {
      key: "consignee",
      label: "Consignee",
      render: (row) => (
        <TooltipText content={row?.consignee}>
          <span className="block max-w-[150px] truncate">
            {row?.consignee || "-"}
          </span>
        </TooltipText>
      ),
    },
    {
      key: "destinationCountry",
      label: "Destination Country",
      render: (row) => row?.destinationCountry || "-",
    },
    {
      key: "loadStatus",
      label: "Load Status",
      render: (row) => (
        <span
          className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(
            row?.status,
          )}`}
        >
          {row?.status || "-"}
        </span>
      ),
    },
    {
      key: "notes",
      label: "Notes",
      render: () => (
        <div className="flex space-x-1">
          <button     className="w-6 h-6 rounded flex items-center justify-center transition-all bg-purple-100 text-purple-700 hover:bg-purple-200">
            <Calendar className="w-4 h-4" />
          </button>
          <button     className="w-6 h-6 rounded flex items-center justify-center transition-all bg-blue-100 text-blue-700 hover:bg-blue-200">
            <FileText className="w-4 h-4" />
          </button>
        </div>
      ),
    },
    {
      key: "upload",
      label: "Upload",
      render: (row) => (
        <div className="flex space-x-1">
          <button
            onClick={() => setSelectedOrderId(row)}
           className="w-6 h-6 rounded flex items-center justify-center transition-all bg-green-100 text-green-700 hover:bg-green-200"
          >
            <Upload className="w-4 h-4" />
          </button>
          <button     className="w-6 h-6 rounded flex items-center justify-center transition-all bg-indigo-100 text-indigo-700 hover:bg-indigo-200">
            <FileText className="w-4 h-4 text-blue-500" />
          </button>
        </div>
      ),
    },

    {
      key: "audit",
      label: "Status Audit",
      render: () => (
        <button     className="w-6 h-6 rounded flex items-center justify-center transition-all bg-yellow-100 text-yellow-700 hover:bg-yellow-200">
          <ClipboardList className="w-4 h-4" />
        </button>
      ),
    },
    {
      key: "delete",
      label: "Can.",
      render: () => (
        <button className="w-6 h-6 rounded flex items-center justify-center transition-all bg-red-100 text-red-700 hover:bg-red-200">
          <Trash2 className="w-4 h-4" />
        </button>
      ),
    },
  ];
};

export const getItemColumns = ({
  handleItemChange,
  uomTypeList,
  quantityTypeList,
}) => {
  console.log("uomTypeList", uomTypeList);
  return [
    {
      key: "sno",
      label: "SNO",
      render: (_, index) => (
        <span className="text-center block">{index + 1}</span>
      ),
    },
    {
      key: "uot",
      label: "UOT",
      render: (row, index) => (
        <input
          type="number"
          value={row?.uot}
          onChange={(e) => handleItemChange(index, "uot", e.target.value)}
          className="w-16 px-2 py-1 text-xs border rounded bg-white dark:bg-slate-700"
        />
      ),
    },
    {
      key: "casesPerUot",
      label: "CASES PER UOT",
      render: (row, index) => (
        <input
          type="number"
          value={row?.casesPerUot}
          onChange={(e) =>
            handleItemChange(index, "casesPerUot", e.target.value)
          }
          className="w-16 px-2 py-1 text-xs border rounded bg-white dark:bg-slate-700"
        />
      ),
    },
    {
      key: "caseCount",
      label: "CASE COUNT",
      render: (row, index) => (
        <div className="flex gap-1">
          <input
            readOnly
            value={
              parseFloat(row?.uot || 0) * parseFloat(row?.casesPerUot || 0)
            }
            className="w-16 px-2 py-1 text-xs border bg-slate-100 dark:bg-slate-800"
          />
          <select
            value={row?.uomTypeId}
            onChange={(e) => {
              handleItemChange(index, "uomTypeId", e.target.value);
              handleItemChange(
                index,
                "uomType",
                e.target.options[e.target.selectedIndex].text,
              );
            }}
            className="w-24 px-1 py-1 text-xs border bg-white dark:bg-slate-700"
          >
            <option>SELECT</option>
            {uomTypeList?.map((uom) => (
              <option key={uom.id} value={uom.id}>
                {uom?.id}
              </option>
            ))}
          </select>
        </div>
      ),
    },
    {
      key: "grossWeightKgs",
      label: "GROSS (Kgs)",
      render: (row, index) => (
        <input
          type="number"
          value={row?.grossWeightKgs}
          onChange={(e) =>
            handleItemChange(index, "grossWeightKgs", e.target.value)
          }
          className="w-20 px-2 py-1 text-xs border rounded bg-white dark:bg-slate-700"
        />
      ),
    },
    {
      key: "netWeightKgs",
      label: "Net (Kgs)",
      render: (row, index) => (
        <input
          type="number"
          value={row?.netWeightKgs}
          onChange={(e) =>
            handleItemChange(index, "netWeightKgs", e.target.value)
          }
          className="w-20 px-2 py-1 text-xs border rounded bg-white dark:bg-slate-700"
        />
      ),
    },
    {
      key: "packing",
      label: "PACKING",
      render: (row, index) => (
        <input
          type="number"
          value={row?.packing}
          onChange={(e) => handleItemChange(index, "packing", e.target.value)}
          className="w-16 px-2 py-1 text-xs border rounded bg-white dark:bg-slate-700"
        />
      ),
    },
    {
      key: "quantity",
      label: "QUANTITY",
      render: (row, index) => (
        <div className="flex gap-1">
          <input
            type="number"
            value={row?.quantity}
            onChange={(e) =>
              handleItemChange(index, "quantity", e.target.value)
            }
            className="w-16 px-2 py-1 text-xs border bg-white dark:bg-slate-700"
          />
          <select
            value={row?.metricId}
            onChange={(e) => {
              handleItemChange(index, "metricId", e.target.value);
              handleItemChange(
                index,
                "metricType",
                e.target.options[e.target.selectedIndex].text,
              );
            }}
            className="w-16 px-1 py-1 text-xs border bg-white dark:bg-slate-700"
          >
            <option>SELECT</option>
            {quantityTypeList?.map((qty) => (
              <option key={qty.id} value={qty.id}>
                {qty.incoterm}
              </option>
            ))}
          </select>
        </div>
      ),
    },
    {
      key: "soNumber",
      label: "SO ID",
      render: (row) => (
        <input
          readOnly
          value={row?.soNumber}
          className="px-2 py-1 text-xs border bg-slate-100 dark:bg-slate-800 "
        />
      ),
    },
    {
      key: "poNumber",
      label: "PO ID",
      render: (row) => (
        <input
          readOnly
          value={row?.poNumber}
          className="px-2 py-1 text-xs border bg-slate-100 dark:bg-slate-800"
        />
      ),
    },
    {
      key: "price",
      label: "PRICE",
      render: (row, index) => (
        <input
          type="number"
          value={row?.price}
          onChange={(e) => handleItemChange(index, "price", e.target.value)}
          className="w-20 px-2 py-1 text-xs border rounded bg-white dark:bg-slate-700"
        />
      ),
    },
    {
      key: "total",
      label: "TOTAL",
      render: (row) => (
        <input
          readOnly
          value={row?.total}
          className="w-20 px-2 py-1 text-xs border rounded bg-white dark:bg-slate-700"
        />
      ),
    },
    {
      key: "source",
      label: "SOURCE",
      render: (row) => (
        <input
          readOnly
          value={row?.source}
          className="w-20 px-2 py-1 text-xs border rounded bg-white dark:bg-slate-700"
        />
      ),
    },
  ];
};
